import React from 'react';
import {
  Grid, Paper, useTheme,
} from '@mui/material';
import useStyles from '../styles';

type LeadFormLeftGridProps = {
    xs?: number|false,
    lg?: number|false,
    backgroundColor?: string,
    bare?: boolean,
    children: React.ReactElement<any, any>,
}

const defaultProps = {
  xs: 12,
  lg: 5,
  backgroundColor: undefined,
  bare: false,
};

export default function LeadFormLeftGridRedesign(props: LeadFormLeftGridProps) {
  const {
    xs, lg, children, backgroundColor, bare,
  } = props;
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Grid
      item
      xs={xs}
      lg={lg}
      component={Paper}
      style={bare ? {
        backgroundColor,
        display: 'block',
        height: '100%',
        overflowY: 'auto',
        padding: 0,
        textAlign: 'left',
      } : {
        backgroundColor: backgroundColor || theme.palette.background.defaultSecondary,
        alignItems: backgroundColor ? 'stretch' : undefined,
        height: backgroundColor ? '100%' : undefined,
        overflowY: 'auto',
        padding: backgroundColor ? '24px 20px' : undefined,
      }}
      borderRadius="10px"
      className={classes.leftGrid}
      square
      elevation={0}
    >
      {children}
    </Grid>
  );
}

LeadFormLeftGridRedesign.defaultProps = defaultProps;
